import { render, staticRenderFns } from "./main.vue?vue&type=template&id=4f04aae6&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=4f04aae6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f04aae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zhenzhaopin\\xxh-zhaopin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f04aae6')) {
      api.createRecord('4f04aae6', component.options)
    } else {
      api.reload('4f04aae6', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=4f04aae6&scoped=true", function () {
      api.rerender('4f04aae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/aiChat/components/chat/widgets/main.vue"
export default component.exports